
import { BrowserRouter, Route, Routes } from "react-router-dom";
import TerminalWindow from "./terminal/components/TerminalWindow";
import V1Layout from "./v1/V1Layout";
import V2Layout from "./v2/V2Layout";
import Desktop from "./macOS/components/Desktop/Desktop";

function App() {
  return (
    <>
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<V2Layout/>} />
          <Route path="/v1" element={<V1Layout/>} />
          <Route path="/terminal" element={<TerminalWindow fullScreen={true} path={true}/>} />
          <Route path="/mac-os" element={<Desktop/>} />
        </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
